export const cs = {
    'nav.today': "Přehled Dnes",
    'nav.calendar': "Kalendář Poptávky",
    'nav.rates': "Ceny a Pravidla",
    'nav.automation': "Automatizace",
    'nav.audit': "Protokol Auditu",
    'nav.settings': "Nastavení",
    'sidebar.status': "Připojeno",
    'stat.occupancy': "Obsazenost",
    'stat.adr': "Prům. Cena (ADR)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Odhad Tržeb",
    'stat.trend.vsLastWeek': "vs Min. Týden",
    'stat.trend.onPace': "Dle plánu",
    'dashboard.actions.title': "Doporučené Akce",
    'dashboard.actions.empty': "Žádné akce nenalezeny.",
    'filter.all': "Vše",
    'filter.pricing': "Ceny",
    'filter.restriction': "Restrikce",
    'action.approve': "Schválit",
    'action.reject': "Zamítnout",
    'action.risk.low': "nízké riziko",
    'action.risk.medium': "střední riziko",
    'action.risk.high': "vysoké riziko",
    'action.label.current': "Aktuální",
    'action.label.proposed': "Navrhované",
    'action.metric.impact': "Dopad",
    'action.metric.why': "Důvod",
    'action.status.executed': "Auto-Provedeno",
    'header.search': "Hledat...",
    'header.logout': "Odhlásit",
    'auto.level.title': "Úroveň Autopilota",
    'auto.level.manual': "Manuální",
    'auto.level.manual.desc': "Schvalujete každé doporučení.",
    'auto.level.assisted': "Asistovaný",
    'auto.level.assisted.desc': "Auto-schválení nízkého rizika. Kontrola velkých změn.",
    'auto.level.auto': "Plně Automatický",
    'auto.level.auto.desc': "AI řídí ceny 24/7 ve vašich limitech.",
    'auto.level.active': "Aktivní",
    'auto.guardrails.title': "Bezpečnostní Limity",
    'auto.guardrails.maxIncrease': "Max. Denní Zvýšení",
    'auto.guardrails.maxIncrease.desc': "Zamezit cenovým šokům.",
    'auto.guardrails.maxDecrease': "Max. Denní Snížení",
    'auto.guardrails.maxDecrease.desc': "Zamezit podcenění.",
    'auto.guardrails.minRate': "Minimální Cena",
    'auto.guardrails.minRate.desc': "Nikdy neprodávat pod touto cenou (Netto).",
    'auto.emergency.title': "Nouzové Řízení",
    'auto.emergency.label': "Nouzové Zastavení",
    'auto.emergency.desc': "Okamžitě pozastavit veškerou automatizaci.",
    'auto.emergency.btn': "POZASTAVIT SYSTÉM",
    'rates.filter.all': "Všechny Typy Pokojů",
    'rates.filter.next14': "Příštích 14 Dní",
    'rates.export': "Exportovat",
    'audit.table.time': "Čas",
    'audit.table.actor': "Uživatel",
    'audit.table.category': "Kategorie",
    'audit.table.action': "Akce",
    'audit.table.details': "Detaily",
    'audit.table.status': "Stav",
    'settings.pms.title': "Připojení PMS",
    'settings.pms.connected': "Připojeno k",
    'settings.pms.disconnect': "Odpojit",
    'settings.account.title': "Účet",
    'settings.account.role': "Role",
    'settings.restart': "Restart Onboardingu",
    'onboard.title': "Připojit PMS",
    'onboard.desc': "Vyberte svůj PMS systém pro synchronizaci.",
    'onboard.connecting': "Připojování...",
    'onboard.connect': "Připojit",
    'onboard.success.title': "Nastavení Dokončeno!",
    'onboard.success.desc': "**SynthHotel Berlin** je nyní synchronizován.",
    'onboard.success.sub': "Importovány 3 typy pokojů, 14 cenových plánů a 243 rezervací.",
    'onboard.btn.dashboard': "Na Nástěnku",
    'action.dynamic.weekend.title': "Zvýšit Cenu na Víkend",
    'action.dynamic.weekend.desc': "Obsazenost > 75% Sobota, silná poptávka (+12 pokojů za 24h).",
    'action.dynamic.minstay.title': "Aktivovat Min. Pobyt 2 Noci",
    'action.dynamic.minstay.desc': "Koncert Taylor Swift. Zamezit pobytům na 1 noc.",
    'action.dynamic.distress.title': "Snížit Cenu (Nízká Poptávka)",
    'action.dynamic.distress.desc': "Obsazenost 35% příští Úterý. Konkurence zlevnila o 10€.",
    'action.dynamic.gap.title': "Vyplnit Mezeru: Zrušit CTA",
    'action.dynamic.gap.desc': "Mezera jedna noc. Zrušit 'Zavřeno pro Příjezd' k prodeji.",
};
